const livia = "#268089"
const liviu = "#268089"
const livquestCalvi = "#A17F56"
const corsica = "#000000"

const colorMap = {
  "livia": livia,
  "liviu": liviu,
  "livquest-calvi": livquestCalvi,
  "corsica": corsica,
}

const themeColorMap = {
  "livia": "#CED3EA",
  "liviu": liviu,
  "livquest-calvi": livquestCalvi,
  "corsica": "#000000",
}


module.exports = {
  content: [
    "./src/pages/**/*.{js,jsx,ts,tsx}",
    "./src/components/**/*.{js,jsx,ts,tsx}",
  ],
  purge: ['./src/**/*.{js,jsx,ts,tsx,html}'],
  darkMode: false, // or 'media' or 'class'
  theme: {
    extend: {
      colors: {
        livia,
        liviu,
        corsica,
        "livquest-calvi": livquestCalvi,
        primary: colorMap[process.env.GATSBY_LIV],
        theme: themeColorMap[process.env.GATSBY_LIV]
      }
    },
  },
  variants: {
    extend: {},
  },
  plugins: [],
}
